export default __webpack_public_path__ + "static/media/pending_icon.2bac75c2.svg";